import React, { useState } from 'react';
import {
  AppProvider, Page, Card, TextField, Button, Banner, BlockStack, Text, InlineStack,
} from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

interface AdminLoginProps {
  onLogin: (email: string, password: string) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

export function AdminLogin({ onLogin, loading, error }: AdminLoginProps) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [errors,   setErrors]   = useState<{ email?: string; password?: string }>({});

  const handleSubmit = async () => {
    const e: typeof errors = {};
    if (!email.trim())    e.email    = 'Email is required.';
    if (!password.trim()) e.password = 'Password is required.';
    if (Object.keys(e).length) { setErrors(e); return; }
    setErrors({});
    await onLogin(email.trim(), password);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <AppProvider i18n={enTranslations}>
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f6f6f7' }}>
        <div style={{ width: 420 }}>
          <Page>
            <BlockStack gap="600">
              <BlockStack gap="100">
                <Text as="h1" variant="heading2xl" alignment="center">GrowthPilot AI</Text>
                <Text as="p" variant="bodyMd" tone="subdued" alignment="center">Admin Panel</Text>
              </BlockStack>

              <Card>
                <BlockStack gap="400">
                  {error && <Banner tone="critical">{error}</Banner>}

                  <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={setEmail}
                    autoComplete="email"
                    error={errors.email}
                  />

                  <div onKeyDown={handleKeyDown}>
                    <TextField
                      label="Password"
                      type="password"
                      value={password}
                      onChange={setPassword}
                      autoComplete="current-password"
                      error={errors.password}
                    />
                  </div>

                  <InlineStack align="end">
                    <Button variant="primary" loading={loading} onClick={handleSubmit}>
                      Sign in
                    </Button>
                  </InlineStack>
                </BlockStack>
              </Card>
            </BlockStack>
          </Page>
        </div>
      </div>
    </AppProvider>
  );
}
